import { render, staticRenderFns } from "./ChecklistModal.vue?vue&type=template&id=35107987"
import script from "./ChecklistModal.vue?vue&type=script&lang=js"
export * from "./ChecklistModal.vue?vue&type=script&lang=js"
import style0 from "./ChecklistModal.vue?vue&type=style&index=0&id=35107987&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports